<template>
  <span class="mta-dchip" :class="'mta-dchip--' + chip.cls">{{ chip.text }} <i v-if="chip.label">{{ chip.label }}</i></span>
</template>

<script>
/** A change chip of the design (.dchip): { cls: 'good' | 'bad' | 'na', text, label } from metricsCalc. */
export default {
  name: 'MetricsDeltaChip',
  props: {
    chip: { type: Object, required: true },
  },
}
</script>
